import { useOrdersOverviewState } from './OrdersOverview.selectors';
import type { OrdersOverviewSort } from './OrdersOverview.types';
import { OrdersOverviewDefaultSort } from './OrdersOverviewConstants';

export function useCurrentOrdersSort(): OrdersOverviewSort {
    const screen = useOrdersOverviewState(s => s.screen);
    const sort = useOrdersOverviewState(s => s.view?.sort);
    return screen === 'custom' && sort ? sort : OrdersOverviewDefaultSort;
}
